/* src/app/components/leads/additional-demographics/additional-demographics.component.css */
.checkbox {
  width: auto !important;
  height: auto !important;
  cursor: pointer !important;
  margin-left: 8px;
  margin-top: 8px;
}
/*# sourceMappingURL=additional-demographics.component-FD7CGVKM.css.map */
